import { hebrewLetterToNote, tokenizeHebrew } from "@/lib/hebrewCryptogram";

// Builds the play-order sequence for a Hebrew phrase.
// Each entry mirrors the English shape so playEngine/Staff can consume it directly.
// `options` is passed through to hebrewLetterToNote ({ root, modeIdx }).
export function buildHebrewSequence(words, options = {}) {
  const out = [];
  words.forEach((word, wordIdx) => {
    if (!word) return;
    const tokens = tokenizeHebrew(word);
    tokens.forEach((tok) => {
      const n = hebrewLetterToNote(tok.glyph, options);
      if (!n) return;
      out.push({
        wordIdx,
        charIdx: tok.startIdx,
        ...n,
      });
    });
  });
  return out;
}
